import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parameter-management-share-of-business-organism',
  templateUrl: './parameter-management-share-of-business-organism.component.html',
  styleUrls: ['./parameter-management-share-of-business-organism.component.css']
})
export class ParameterManagementShareOfBusinessOrganismComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
